import { Grid } from '@mui/material';
import AdminMetricCard from '../../shared/AdminMetricCard';
import { AuditLogStats } from '../../../../types/admin';
import { formatNumber } from '../../../../utils/formatters';

interface AuditLogStatsCardsProps {
  stats: AuditLogStats;
  loading?: boolean;
}

export default function AuditLogStatsCards({ stats, loading }: AuditLogStatsCardsProps) {
  const topAdmin = stats.actions_by_admin[0];
  const topAction = stats.actions_by_type[0];

  return (
    <>
      <Grid item xs={12} sm={6} md={3}>
        <AdminMetricCard
          title="Total Actions"
          value={formatNumber(stats.total_actions)}
          subtitle="Last 30 days"
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <AdminMetricCard
          title="Failed Actions"
          value={formatNumber(stats.failed_actions)}
          subtitle={`${((stats.failed_actions / stats.total_actions) * 100).toFixed(1)}% failure rate`}
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <AdminMetricCard
          title="Most Active Admin"
          value={topAdmin?.admin_name || 'N/A'}
          subtitle={topAdmin ? `${formatNumber(topAdmin.count)} actions` : ''}
          loading={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <AdminMetricCard
          title="Top Action Type"
          value={topAction?.type || 'N/A'}
          subtitle={topAction ? `${topAction.percentage.toFixed(1)}% of actions` : ''}
          loading={loading}
        />
      </Grid>
    </>
  );
}
